<template>
  <section>
    欢迎登陆资讯管理中心
  </section>
</template>

<script>
  export default {
  }

</script>

<style scoped>

</style>
